import { SettingsSidebar } from "../../../../../externalComponents/SettingsSidebar";
import { PageHeading } from "../../../../../externalComponents/PageHeading";
import { OverflowFrame } from "../../../../../externalComponents";
import { Button } from "../../../../../externalComponents/tailwind/button";
import { useNavigate } from "react-router";
import { Text } from "../../../../../externalComponents/tailwind/text";

export default function ZendeskSuccessPage() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("success") === "true";
  const isDisconnected = urlParams.get("disconnected") === "true";
  const isError = urlParams.get("error") === "true";

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Zendesk integration" />
        <OverflowFrame>
          <div className="flex flex-col items-center justify-center h-full space-y-4">
            {isSuccess && (
              <Text className="text-center">
                Your Zendesk integration has been successfully set up!
              </Text>
            )}
            {isDisconnected && (
              <Text className="text-center">
                Your Zendesk integration has been successfully removed!
              </Text>
            )}
            {isError && (
              <Text className="text-center">
                Authorization was declined, or your Zendesk host/OAuth client
                settings are incorrect. Please check them and try again.
              </Text>
            )}
            <Button
              color="primaryButton"
              onClick={() => navigate("/settings/data/integrations")}
            >
              {isError ? "Try again" : "OK"}
            </Button>
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
